<template>
<div class="sidebar">
   <div class="sidebar-overlay" v-bind:class="{ 'sidebar-overlay-active': sidebarOpen }" @click="toggle" ></div>
   <div class="sidebar-menu" v-bind:class="{ 'sidebar-menu-active': sidebarOpen }">
      <slot name="sidebar" ></slot>
      
      <el-menu default-active="-1" class="app-side-menu" :router="true">
         <el-menu-item index="/home" v-if="$route.path!='/home'">Home</el-menu-item>

         <el-submenu index="infogenerali">
            <template slot="title">Informazioni Generali</template>
            <el-menu-item index="/loadpage/info-generali/citta" class="font-color-e">Città di Roma</el-menu-item>
            <el-menu-item index="/loadpage/info-generali/sede" class="font-color-e">Sede del congresso</el-menu-item>
            <el-menu-item index="/loadpage/info-generali/premi" class="font-color-e">Premi</el-menu-item>
            <el-menu-item index="/loadpage/info-generali/ecm" class="font-color-e">ECM</el-menu-item>
         </el-submenu>

         <el-submenu index="iscrizioni">
            <template slot="title">Iscrizioni</template>
            <el-menu-item index="/loadpage/info-generali/quote" class="font-color-e">Modalità di iscrizione</el-menu-item>
            <!--
            <el-menu-item index="iscrizioni" class="font-color-e">Iscrizioni</el-menu-item> 
            <el-menu-item index="iscrizioni" class="font-color-e">Iscrizioni Aziendali</el-menu-item>
            -->
         </el-submenu>

         <el-menu-item index="/loadpage/comitati/comitati">Comitati</el-menu-item>

         <el-submenu index="programma">
            <template slot="title">Programma</template>
            <el-menu-item index="/loadpage/programma/programma" class="font-color-e">Congresso</el-menu-item>

            <!-- <li class="el-menu-item font-color-c"><a href="/2017/documenti/Programma_congresso.pdf"  target="_blank">Congresso</a></li> -->
            <!-- <li class="el-menu-item font-color-c"><a href="/2017/documenti/Programma_precongressuali.pdf"  target="_blank">Pre Congressuali</a></li> -->
            <!-- <li class="el-menu-item font-color-c"><a href="https://docs.biomedia.net/2017/congressi_nazionali/SIP/Programma.pdf"  target="_blank">Download</a></li> -->
         </el-submenu>

         <el-menu-item index="/loadpage/abstract/abstract">Abstract</el-menu-item>

         <el-menu-item index="/loadpage/info-generali/prenotazione-alberghiera">Prenotazione Alberghiera</el-menu-item>

         <el-submenu index="aziende">
            <template slot="title">Aziende</template>
            <el-menu-item index="/loadpage/aziende/sponsor" class="font-color-e">Sponsor</el-menu-item>
            <el-menu-item index="/loadpage/aziende/iscrizioni" class="font-color-e">Iscrizioni</el-menu-item>
         </el-submenu>

         <el-menu-item index="/loadpage/info/congressi-precedenti" >Congressi Precedenti</el-menu-item>

         <el-menu-item index="/loadpage/contatti/segreteria-organizzativa" >Contatti</el-menu-item>
         <!-- <li class="el-menu-item" @click="$teras.event.emit('logout')" href="mailto:info@athens2017.org">LOGOUT</li> -->

      </el-menu>

      <slot name="footer" v-if="false">Se non <b>passo</b> del testo</slot>
   </div>
</div>
</template>

<script>


export default {
  name: 'sidebar',
  data() {
    return {
      sidebarOpen: false
    }
  },
  created(){
    var parent = this
    this.$teras.event.on('sidebarToggle', this.toggle)
    this.$teras.event.on('sidebarClose', this.close)
    this.$teras.event.on('routerChange', this.close)
  },
  methods:{
    close(){
      this.sidebarOpen = false
    },
    toggle () {
      this.sidebarOpen = !this.sidebarOpen
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
.sidebar-overlay{
  position:fixed;
  z-index: 1000;
  height: 100vh;
  width: 100vw;
  left:-100vw;
  background: #ffffff;
  opacity: 0;
  transition-duration: .4s;
}.sidebar-overlay-active{
  opacity: 0.7;
  left:0;
}.sidebar-menu{
  z-index: 1000;
  top:0;
  position:fixed;
  height: 100vh;
  width: 0;
  background:#3E69B9;
  transition-duration: .4s;
  overflow:auto;
  padding-top:40px;
}#app.device-iOS .sidebar-menu{
  padding-top:60px !important;
}.sidebar-menu .el-menu{
  border:none !important;

}.sidebar-menu-active{
  width: 280px;
}.app-side-menu{
  padding-top:16px;
  background: transparent !important;
}.app-side-menu .el-menu-item, .app-side-menu  .el-submenu__title{
  color:#ffffff;
  font-size: 1.8rem;
  height: 46px;
  line-height: 46px;
}.app-side-menu .el-menu-item.is-active{
  color:#ffffff;
}.app-side-menu .el-submenu .el-menu-item:hover,.app-side-menu  .el-submenu__title:hover{
  color:#ffffff;
}.app-side-menu .el-submenu .el-menu li{
  color:#424F5C;
  line-height: initial;
  padding: 10px 0;
}.app-side-menu .el-submenu .el-menu li i{
  position:fixed;
  left: 15px;
  margin:2px 0 0 0;
  display:none;
}.app-side-menu .el-menu-item .material-icons, .app-side-menu .el-submenu__title  .material-icons{

  margin-right: 10px;
  vertical-align: baseline;
}.app-side-menu .el-submenu .el-menu{
  background: #b5f29f;
  color:#3E69B9 !important;
}.el-submenu .el-menu-item:hover, .el-submenu__title:hover{
  background-color: #b5f29f !important;
  color:#3E69B9 !important;


}.app-side-menu .el-submenu .el-menu li.double{
  color:#424F5C;
  height:auto;
  
}.app-side-menu .el-submenu .el-menu li.double .more{
  font-style: italic;
  font-size:1.6rem;
}
</style>
